export default __webpack_public_path__ + "static/media/download-icon.d527f9ca.svg";